import React from 'react';
import PropTypes from 'prop-types';
import AuraIcon from '../ui/AuraIcon.jsx';
import AnimatedNumber from '../ui/AnimatedNumber.jsx';

/**
 * „✦ +38“ — die verdiente Aura einer Session (Motion-Kit `.eo-aura`).
 * Mit `from` zaehlt die Zahl hoch, z.B. bei einem frisch eingetroffenen Eintrag.
 */
const AuraPill = ({ value, from, delay, className = '' }) => (
  <span
    className={[
      'inline-flex shrink-0 items-center gap-1 rounded-full bg-primary-soft px-2.5 py-1',
      'text-[13px] font-semibold leading-none text-primary whitespace-nowrap',
      className,
    ].join(' ')}
    aria-label={`${value} Aura verdient`}
  >
    <AuraIcon className="h-4 w-4" aria-hidden="true" />
    <span aria-hidden="true">
      <AnimatedNumber value={value} from={from} delay={delay} format={(n) => `+${n}`} />
    </span>
  </span>
);

AuraPill.propTypes = {
  value: PropTypes.number.isRequired,
  from: PropTypes.number,
  delay: PropTypes.number,
  className: PropTypes.string,
};

export default AuraPill;
